import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ServicePaymentType } from '@/modules/HealthPlan/HealthPlan.types';
import { RenewalServiceConfig } from '@/modules/Renewals/renewals.types';

import PaymentRuleField from './PaymentRuleField';

interface Props {
  service: RenewalServiceConfig;
  serviceIndex: number;
  tierIndex: number;
  testId?: string;
}

const TiersSectionItem: React.FC<Props> = ({
  service,
  serviceIndex,
  tierIndex,
  testId = 'edit-amounts-modal',
}) => {
  return (
    <Box
      pad="spacing16"
      border={{ size: 'small', color: 'border1' }}
      round="container2Round"
      background="canvas"
      gap="spacing8"
    >
      <Box gap="spacing4">
        <Text size="medium" weight={700} color="textBody">
          {(service.services || []).map((s) => s.name).join(', ')}
          {(service.services || []).length > 0 ? ':' : ''}
        </Text>
        <Box direction="row" align="center" style={{ flexWrap: 'wrap' }}>
          <Text color="textBody" margin={{ right: 'spacing24' }}>
            {service.claimValue != null ? `$${service.claimValue.toFixed(2)}` : 'Amount is not specified'}
          </Text>
          <Text color="textBody">
            {service.isAppliedDeductible ? 'Applied to deductible' : 'Not applied to deductible'}{' '}
            <Box
              as="span"
              width="8px"
              height="8px"
              round="full"
              background={service.isAppliedDeductible ? 'success' : 'warning'}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
          </Text>
        </Box>
        {service?.paymentRules?.length ? (
          <Box height="1px" background="border1" margin={{ top: 'spacing8' }} />
        ) : undefined}
      </Box>

      {/* Payment Rules with editable amounts */}
      {(service.paymentRules || []).map((rule, ruleIndex) => (
        <PaymentRuleField
          key={`${rule.planName}-${ruleIndex}`}
          rule={rule}
          ruleIndex={ruleIndex}
          tierIndex={tierIndex}
          serviceIndex={serviceIndex}
          isPercentageType={service.paymentType === ServicePaymentType.PERCENTAGE}
          testId={testId}
        />
      ))}
    </Box>
  );
};

export default TiersSectionItem;
